<template lang="pug">
server-data(
  :method="isMemberParticipateEvent(constants.EVENT_ID)"
  :serialize-data="serializeData"
  :start-loading-value="true"
  v-slot="{ serverData: showSpecialDialog, loading: isLoading }"
)
  template(v-if="isLoading")
    v-skeleton-loader(type="list-item@5")

  template(v-else)
    with-actions(
      v-on="$listeners"
    )
      template(v-if="showSpecialDialog")
        .list.text-body-1
          p Протокол о подведении итогов конкурса можно скачать по&nbsp;
            | #[a(href="https://disk.yandex.ru/i/D6yw0ZIMJMJKjw").link ссылке]
          p Сертификаты участников, победителей и призеров можно скачать по&nbsp;
            | #[a(href="https://disk.yandex.ru/d/EfIEpKxQ0DBNvQ").link ссылке]
          p До 12 августа в систему будут загружены сертификаты участников, призеров и победителей.&nbsp;
            | Данные протокола брались из формы регистрации – если вы видите неточность, просьба&nbsp;
            | оперативно написать на почту #[a(href="mailto:art_tech@fedcdo.ru").link art_tech@fedcdo.ru]
          p По положению конкурса планировался финальный этап, в рамках которого команды могли бы доработать.&nbsp;
            | свой проект под руководством экспертов. Изучив работы победителей, мы приняли решение о возможности&nbsp;
            | участия в финальном этапе по желанию: если команда хочет доработать продукт и воплотить идею в жизнь,&nbsp;
            | то напишите на почту #[a(href="mailto:art_tech@fedcdo.ru").link art_tech@fedcdo.ru] до 15 августа&nbsp;
            | – мы поможем с расходными материалами и оборудованием.&nbsp;
            | Если же ребята считают, что работа закончена – отлично, мы поздравляем их с успехом и ждем на новых конкурсах.
          p Спасибо руководителям команд и замечательным участникам и до встречи на других мероприятиях!
      template(v-else)
        .list.text-body-1
          p Заполните свой профиль
          p Ознакомьтесь со списком активных мероприятий
          p Создайте свою команду в разделе "команды друзей"
</template>

<script>
import WithActions from '../components/WithActions.vue';

const EVENT_ID = 12785;

export default {
  name: 'MemberWelcomeVcht',
  components: {
    WithActions,
  },
  data() {
    return {};
  },
  computed: {
    constants() {
      return {
        EVENT_ID,
      };
    },
  },
  created() {},
  methods: {
    isMemberParticipateEvent(id) {
      return () => this.$api.user.getParticipateUser(id);
    },
    serializeData(data) {
      return !!data.member;
    },
  },
};
</script>
